<template>
  <common-filter :title="$t('logging.logFilter')" @confirm="confirmFilter">
    <div class="filter-group filter-group-flex">
      <div class="filter-group__part filter-group__part_lg">
        <label class="filter-label">{{ $t('general.date') }}</label>
        <base-reset-button v-if="localDates.startDate" @input="clearDates"></base-reset-button>
        <base-calendar-wrap>
          <range-calendar
            :start-date="localDates.startDate"
            :end-date="localDates.endDate"
            @input="changeDates"
          ></range-calendar>
        </base-calendar-wrap>
      </div>
      <div class="filter-group__part">
        <label class="filter-label">{{ $t('general.id') }}:</label>
        <base-reset-button v-if="localId" v-model="localId"></base-reset-button>
        <id-filter v-model.number="localId"></id-filter>
      </div>
    </div>

    <div class="filter-group">
      <label class="filter-label">{{ $t('logging.entity') }}:</label>
      <base-reset-button v-if="localEntity.length" v-model="localEntity"></base-reset-button>
      <status-filter v-model="localEntity" :status-list="entityList"></status-filter>
    </div>

    <div class="filter-group">
      <label class="filter-label">{{ $t('logging.method') }}:</label>
      <base-reset-button v-if="localMethods.length" v-model="localMethods"></base-reset-button>
      <status-filter v-model="localMethods" :status-list="methodList"></status-filter>
    </div>
  </common-filter>
</template>

<script>
import('@/styles/components/filter.less')

export default {
  name: 'PageLoggingFilter',
  mixins: [],
  components: {
    CommonFilter: () => import('@/components/Filters/PageCommonFilter.vue'),
    StatusFilter: () => import('@/components/Filters/StatusFilter.vue'),
    BaseResetButton: () => import('@/base/BaseResetButton.vue'),
    RangeCalendar: () => import('@/plugins/DateRangeInput.vue'),
    BaseCalendarWrap: () => import('@/base/BaseCalendarWrap'),
    IdFilter: () => import('@/components/Filters/IdFilter.vue')
  },
  props: {
    isMultiple: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    localMethods: [],
    localEntity: [],
    localDates: {
      startDate: null,
      endDate: null
    },
    localId: null
  }),
  computed: {
    methodList() {
      let methods = {}
      methods[0] = {
        title: 'Create',
        color: 'success'
      }
      methods[1] = {
        title: 'Patch',
        color: 'secondary'
      }
      methods[2] = {
        title: 'Remove',
        color: 'danger'
      }
      return methods
      //return ['Create', 'Patch', 'Remove']
    },
    entityList() {
      let entity = {}
      entity[0] = { title: 'Patients' }
      entity[1] = { title: 'Courses' }
      entity[2] = { title: 'Trainings' }
      entity[3] = { title: 'Users' }
      entity[4] = { title: 'Hospitals' }
      return entity
    }
  },
  mounted() {},
  methods: {
    confirmFilter() {
      let index = this.localMethods[0]
      let method = this.localMethods.length > 0 ? this.methodList[index].title : null

      index = this.localEntity[0]
      let entity = this.localEntity.length > 0 ? this.entityList[index].title : null

      let confirmData = {
        method: method,
        entity: entity,
        userId: this.localId,
        dates: {
          startDate: this.localDates.startDate ? this.moment(this.localDates.startDate) : null,
          endDate: this.localDates.endDate ? this.moment(this.localDates.endDate) : null
        }
      }
      this.$emit('confirm', confirmData)
    },
    clearDates() {
      this.changeDates(null, null)
    },
    changeDates(start, end) {
      this.localDates.startDate = start
      this.localDates.endDate = end
    }
  }
}
</script>
